import { Action, ReducerState, ActionType } from "../types/alert";

const initState = () => ({
  show: false,
  msg: "",
});

const alert = (state = initState(), action: Action): ReducerState => {
  switch (action.type) {
    case ActionType.CLOSE_ALERT:
      return Object.assign({}, state, {
        show: false,
        msg: "",
      });

    case ActionType.OPEN_ALERT:
      return Object.assign({}, state, {
        show: true,
        msg: action.payload,
      });

    default:
      return state;
  }
};

export default alert;
